import React from 'react';
import { PanelLayout } from '../../layout/Panel/Panel';
import { SpacingCustom } from '../../layout/Spacing/SpacingCustom';
import IconComponent from '../../shared/IconComponents/IconComponent';
import { CleanButton } from '../../ui/CleanButton';

interface IChatBotIconProps {
    setShowChat: (value: React.SetStateAction<boolean>) => void;
}

export const ChatBotIcon: React.FC<IChatBotIconProps> = ({ setShowChat }) => {
    return (
        <div
            style={{
                position: 'fixed',
                bottom: '0',
                right: '0',
                zIndex: '2',
            }}
        >
            <CleanButton func={() => setShowChat(true)}>
                <SpacingCustom paddingBottom={3} paddingRight={3}>
                    <PanelLayout color="accent-blue" radius="full" borderIntensity={0}>
                        <IconComponent size={5} iconName={'Chatbot_white_transparent_02'} />
                    </PanelLayout>
                </SpacingCustom>
            </CleanButton>
        </div>
    );
};
